import React from 'react';
import {List, ListItem} from 'material-ui/List';
import Divider from 'material-ui/Divider';
import ChevronRight from 'material-ui/svg-icons/navigation/chevron-right';
import { Redirect } from 'react-router-dom';
import customerIcon from '../../img/customerBlue.svg';
import FontIcon from 'material-ui/FontIcon';
import {LoomisColors} from '../../lib/LoomisColors';
import translate from '../../lib/i18n/translate'

import './CustomerList.css';

const headerIcon = {
    color: LoomisColors.darkBlue,
}

const CustomerList = ({ customers, history, strings }) => {
    const {ChooseCustomer} = strings;
    if(customers.length === 1) {
        return (<Redirect to={`/customers/${customers[0].id}`}/>);
    }

    return (
        <div className="container">
        <div className="mainContent">
            <div className="header">
                <FontIcon className="material-icons" style={headerIcon}>public</FontIcon>
                <h1>{ChooseCustomer}</h1>
            </div>
            <List>
                {customers.map(customer =>
                    <div key={customer.id}>
                        <Divider/>
                        <ListItem
                            onTouchTap={() => history.push(`/customers/${customer.id}`)}
                            leftIcon={<img src={customerIcon} alt="Customer icon" className="svgIcon"/>}
                            rightIcon={<ChevronRight /> }
                            primaryText={customer.name}/>
                    </div>
                )
                }
            </List>
        </div>
        </div>
    )
};

export default translate('CustomerList')(CustomerList);



// WEBPACK FOOTER //
// ./src/components/customerList/CustomerList.js